export class OrganizationVerifyDeleteRecoverRequest {
  token: string;

  constructor(token: string) {
    this.token = token;
  }
}
